"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_base_1 = require("native-base");
const ClaimGraph_1 = __importDefault(require("./ClaimGraph"));
const SapporoBannerAd_1 = __importDefault(require("./SapporoBannerAd"));
const SapporoLikePanel_1 = __importDefault(require("./SapporoLikePanel"));
const ClaimHistory_1 = require("./ClaimHistory");
const getUser_1 = require("./auth/getUser");
const Splash_1 = __importDefault(require("./Splash"));
const SapporoClaimView_1 = __importDefault(require("./SapporoClaimView"));
const SapporoHistory = ({ appIsActive, getImage, getUIComponents, victory, getLocationView, }) => {
    const user = (0, react_1.useContext)(getUser_1.UserContext);
    const historyResults = (0, react_1.useContext)(ClaimHistory_1.ClaimHistoryContext);
    const history = historyResults ? historyResults.history : [];
    const UI = getUIComponents();
    // useEffect(() => {
    //   if (appIsActive) {
    //     return subscribeToHistory(() => {
    //       onRefresh(false);
    //     });
    //   }
    // }, [appIsActive]);
    (0, react_1.useEffect)(() => {
        if (user) {
            console.log('passedUser EFFECT', user);
        }
    }, [user]);
    //   useEffect(() => {
    //     analytics().logScreenView({
    //       screen_class: 'view',
    //       screen_name: 'history',
    //     });
    //   });
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const [paginationToken, setPaginationToken] = react_1.default.useState(undefined);
    const onEndReached = () => {
        // if we are at the end, but don't have a new token, skip it
        if (paginationToken) {
            console.log('ONEND REACHED', paginationToken);
            setRefreshing(true);
            onRefresh(false);
        }
        else {
            console.log('No pagination token');
        }
    };
    const onRefresh = (clearCache) => {
        if (user && user.uid) {
            console.log('ONREFRESH', paginationToken, clearCache);
            //      setRefreshing(true);
            //   getClaimHistory(
            //     user.uid,
            //     10,
            //     clearCache ? undefined : paginationToken,
            //   ).then(results => {
            //     const {lastItemToken, data} = results;
            //     console.log('last item token onRef', lastItemToken);
            //     setPaginationToken(lastItemToken);
            //     if (data) {
            //       setHistory(data);
            //     }
            //     setRefreshing(false);
            //   });
        }
        else {
            console.log('NO USER PRESENT.  NOT LOADING HISTORY');
        }
    };
    const [fullViewClaim, setFullViewClaim] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        console.log('HISTORY RUNNING ONCE');
        if (user) {
            console.log('HISTORY RUNNING ONCE GET EM');
            onRefresh(true);
        }
    }, [user, appIsActive]);
    const renderClaimCard = ({ item }) => {
        var _a;
        const userScored = item && item.userReaction && item.userReaction.like ? true : false;
        const score = (item === null || item === void 0 ? void 0 : item.reactionScore) || 0;
        const count = (item === null || item === void 0 ? void 0 : item.reactionCount) || 0;
        //    console.log('LIKE PANEL', item );
        const bgColor = item.approved ? 'white' : 'warning.200';
        return (react_1.default.createElement(native_base_1.Pressable, { onPress: () => setFullViewClaim(item) },
            react_1.default.createElement(native_base_1.Box, { flex: 1, borderBottomWidth: "1", borderColor: "coolGray.200", pt: "5", pl: "2", pb: "1", bg: bgColor },
                react_1.default.createElement(native_base_1.HStack, { space: 3, justifyContent: "space-between" },
                    react_1.default.createElement(native_base_1.Center, null,
                        react_1.default.createElement(native_base_1.VStack, null,
                            react_1.default.createElement(ClaimGraph_1.default, { size: 75, claim: item, includeLabels: false, getUIComponents: getUIComponents, getImage: getImage, victory: victory }),
                            react_1.default.createElement(native_base_1.Text, { fontSize: "xs", textAlign: 'center' }, "Significance"))),
                    react_1.default.createElement(native_base_1.VStack, { width: "80%", mr: 20 },
                        react_1.default.createElement(native_base_1.Text, { mr: 35, _dark: {
                                color: 'warmGray.50',
                            }, color: "coolGray.800", fontStyle: 'bold', fontSize: 'xl' }, item.header),
                        react_1.default.createElement(native_base_1.Text, { fontSize: "xs", _dark: {
                                color: 'warmGray.50',
                            }, color: "coolGray.800", alignSelf: "flex-start" },
                            item.toLocalTimeString(),
                            " (",
                            item.toRelativeTimeString(),
                            ")"),
                        react_1.default.createElement(native_base_1.Text, { fontSize: "xs", _dark: {
                                color: 'warmGray.50',
                            }, color: "coolGray.800", alignSelf: "flex-start" },
                            "Idiocy: ",
                            item.idiocy,
                            " \u2022 Style: ",
                            item.spirit,
                            " \u2022 Reach:",
                            ' ',
                            item.reach),
                        react_1.default.createElement(native_base_1.Text, { fontSize: "xs", _dark: {
                                color: 'warmGray.50',
                            }, color: "coolGray.800", alignSelf: "flex-start" },
                            "Guard: ",
                            react_1.default.createElement(native_base_1.Text, { bold: true }, (_a = item.user) === null || _a === void 0 ? void 0 : _a.displayName)),
                        !!item.activeStart && (react_1.default.createElement(native_base_1.Text, { fontSize: "xs", _dark: {
                                color: 'warmGray.50',
                            }, color: item.isActive() ? 'lightBlue.800' : 'coolGray.800', alignSelf: "flex-start" },
                            "Active: ",
                            item.toActiveString())),
                        react_1.default.createElement(native_base_1.Box, { width: "100%", justifyContent: 'space-between', pr: 1 },
                            react_1.default.createElement(SapporoLikePanel_1.default, { busy: false, staticOnly: true, userReaction: item === null || item === void 0 ? void 0 : item.userReaction, userScoreValue: 0, reactionCount: count, reactionScore: score, onScoreChange: (v) => {
                                    console.log('Changing', v);
                                }, saveScore: (v) => {
                                    console.log('SAVE', v);
                                }, onPress: () => {
                                    console.log('PRESSING ME');
                                }, userScored: userScored })))),
                !item.approved && (react_1.default.createElement(native_base_1.Text, { fontSize: "lg", color: "lightBlue.800", alignSelf: "center", fontFamily: 'Montserrat', bold: true }, "Pending")))));
    };
    if (!user || !history || history.length === 0) {
        return (react_1.default.createElement(Splash_1.default, { getUIComponents: getUIComponents, spinner: true, getImage: getImage }));
    }
    const styles = {
        top: {
            marginBottom: 'auto',
            marginTop: 10,
        },
        bottom: {
            marginBottom: 10,
            marginTop: 'auto',
        },
        center: {
            marginBottom: 10,
            marginTop: 10,
        },
    };
    return (react_1.default.createElement(native_base_1.Box, { pb: 5, pl: 5, bg: UI.background, flex: 1 },
        react_1.default.createElement(native_base_1.Center, null,
            react_1.default.createElement(native_base_1.Heading, { pb: 3, pt: 5, size: "lg", color: "white", fontFamily: 'Montserrat' }, "Claim History")),
        react_1.default.createElement(native_base_1.VStack, { rounded: "lg", m: 3, p: 3, flex: 1, bg: "white" }, (history && history.length > 0) && (react_1.default.createElement(native_base_1.FlatList, { onEndReached: onEndReached, onEndReachedThreshold: 0.33, data: history, renderItem: renderClaimCard, keyExtractor: (item) => item.id || '' }))),
        react_1.default.createElement(native_base_1.Modal, { bg: UI.background, isOpen: !!fullViewClaim, onClose: () => setFullViewClaim(undefined) },
            react_1.default.createElement(native_base_1.Modal.Content, Object.assign({ flex: 1, width: "97%", maxWidth: 600 }, styles.top),
                react_1.default.createElement(SapporoClaimView_1.default, { refreshClaim: () => {
                        return new Promise(resolve => {
                            console.log('We did this');
                            resolve('we done');
                        });
                    }, active: appIsActive, victory: victory, getUIComponents: getUIComponents, getImage: getImage, getLocationView: getLocationView, passedUser: user, claim: fullViewClaim }),
                react_1.default.createElement(native_base_1.Center, { p: 5 },
                    react_1.default.createElement(native_base_1.Button.Group, { space: 2 },
                        react_1.default.createElement(native_base_1.Button, { bg: "blue.900", onPress: () => {
                                setFullViewClaim(undefined);
                            } }, "Close"))))),
        react_1.default.createElement(SapporoBannerAd_1.default, { location: "history" })));
};
exports.default = SapporoHistory;
/**
 *         refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={() => {
              onRefresh(true);
            }}
          />
        }

 */
